<template>
<div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5">
  <loading v-if="loadingState || loadingState2" />
  <div class="container  mt-3">

    <div class="row justify-content-center">
      <div class="col-md-12 center ">
        <h1 class="Regular center  pt-4 h0">Accedi</h1>
      </div>
    </div>

    <div class="row justify-content-center pt- mb-5">

      <div class="col-md-6 col-lg-4 pt-4 pb-4 vaillantCont">
        <form class="login widthFull" id="login-form" @submit.prevent="login">
          <div v-if="confirmed && !to_activate" class="widthFull">

            <div class="form-row justify-content-center">
              <div class="col-md-12 mb-1">
                <div class="group custInput">
                  <input type="text" v-model="username" v-validate="{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}" class="form-control" id="username" name="username" data-vv-as="Email"
                    :class="{ 'is-invalid': errors.has('username'), valid: !!username }">
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="niceInputLabel" for="username">Email</label>

                  <div v-if="errors.has('username')" class="invalid-feedback">
                    {{ errors.first("username") }}

                  </div>
                  <div v-if="socialEmail" class="text-danger mt-3">
                    Sei registrato con: <strong class="text-capitalize">{{ socialEmail }}</strong>. Per effetuare accesso clicca sulla apposita icona
                  </div>
                </div>
              </div>
            </div>

            <div class="form-row justify-content-center">
              <div class="col-md-12 mb-3">

                <div class="group custInput">
                  <input type="password" v-model="password" v-validate="{required:true, min: 8, max: 56}" class="form-control" id="password" name="password" data-vv-as="Password" :class="{ 'is-invalid': errors.has('password'), valid: !!password }">
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="niceInputLabel" for="password">Password</label>

                  <div v-if="errors.has('password')" class="invalid-feedback">
                    {{ errors.first("password") }}
                  </div>

                  <div v-if="loginerror" class="mb-3">
                    <span class="formError ml-1">Email o password errati.</span>
                  </div>
                  <!--
                   <font-awesome-icon  class="seePass" @click="switchVisibility"  icon="eye" size="2x" />
                 -->

                </div>
              </div>
            </div>

          </div>
          <div v-if="confirmed && !to_activate" class="widthFull">
            <div class="form-row justify-content-center">
              <div v-if="hasregistration" class="col-md-12 mb-3">
                <router-link class="black Medium pl-3 " to="/forgot-password">Password dimenticata?</router-link>
              </div>
            </div>
            <div class="form-row justify-content-center">

              <div class="col-md-12 text-center">
                <button class="btn btn-primary  btnYellow shadow mb-4 mt-4" type="submit">Accedi</button>
              </div>

              <div v-if="social" class="text-danger mb-5 ">
                Sei registrato con altra social network: <strong class="text-capitalize">{{ social }}</strong> Per effetuare accesso clicca sulla apposita icona
              </div>

            </div>
          </div>

        </form>
      </div>

      <div class="col-md-12 col-lg-12 pt-1 ">
        <div class="row justify-content-center divider"> </div>
      </div>

      <div v-if="hasregistration" class="col-md-6 col-lg-4 pt-1 pb-4 mb-5 vaillantCont">
        <div v-if="confirmed && !to_activate">
          <div class="form-row justify-content-center">
            <div class="col-md-12 mb-0 pb-0 text-center">
              <h1 v-if="moment(finish) > moment()" class="">
                <h4 class=" Regular center glade pb-2">Non sei registrato?</h4>
                <router-link v-if="!isAuthenticated" class="btn btn-primary  btnYellow" to="/registration">
                  Registrati
                </router-link>
                </strong>
              </h1>
            </div>
          </div>
        </div>

        <div v-else-if="resend_success && !to_activate">
          <div class="form-row justify-content-center">
            <div class="col-md-12 mb-3">
              <h4 class="mb-4 center text-red sans-serifBold"><strong>L'e-mail di conferma della registrazione è stata inviata alla tua casella di posta elettronica</strong></h4>

            </div>
            <div class="col-md-12 mb-3 center">
              <router-link class="btn btn-primary" to="/login" @click.native="resetState">Accedi</router-link>
            </div>
          </div>
        </div>
        <div v-else-if="!resend_success && !to_activate && corporateClient != 'emicom'" >
          <div class="form-row justify-content-center">
            <div class="col-md-12 mb-3">
              <h4 class="mb-4 center text-red sans-serifBold"><strong>Non hai ricevuto l'e-mail <br />di conferma della registrazione?</strong></h4>
              <p class="mb-4 mt-5">Controlla che il tuo gestore di posta elettronica non abbia inserito il messaggio nella cartella di posta indesiderata (spam) o con destinatario sconosciuto.</p>
              <p class="mb-4">Se sono passati diversi minuti da quando hai fatto la richiesta e il messaggio non è ancora arrivato clicca sul bottone qui sotto per chiederne il reinivio.</p>

            </div>
            <div class="col-md-12 mb-3 center">
              <button class="btn btn-primary mt-3" v-on:click.prevent="resendConfirmEmail">Invia</button>
            </div>
          </div>
        </div>
        <div v-if="to_activate">
          <div class="form-row justify-content-center">
            <div class="col-md-12 mb-3">
              <h4 v-if="corporateClient != 'hoval'" class="mb-4 center text-red sans-serifBold"><strong>La tua richiesta è in fase di approvazione.</strong>
              <br/><br/>A breve riceverai la conferma via email e potrai accedere alla piattaforma.</h4>
              <h4 v-else class="mb-4 center text-red sans-serifBold"><strong>La tua richiesta è in fase di approvazione.</strong>
              </h4>
            </div>
            <div class="col-md-12 mb-3 center">
              <router-link class="btn btn-primary mt-3" to="/">Home</router-link>
            </div>
          </div>
        </div>

        </form>

      </div>

      <div class="col-md-12 col-lg-12 pt-1">
        <div class="row justify-content-center divider"> </div>
      </div>


    </div>

  </div>

</div>

</div>


</div>
</template>

<script>
import { AUTH_REQUEST, AUTH_SOCIAL } from "actions/auth";
import { mapGetters, mapState } from "vuex";
import axios from "axios";
const moment = require("moment");

export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      token: "",
      loading: false,
      tempMail: "",
      socialEmail: false,
      social: "",
      confirmed: true,
      resend_success: false,
      loadingState2: false,
      passwordFieldType: "password",
      moment: moment,
      finish: process.env.FINISH,
      to_activate: false,
      hasregistration: true,
      corporateClient: "",
    };
  },
  methods: {
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    },
    login: function () {
      const { username, password } = this;

      this.$validator.validate().then((valid) => {
        if (valid) {
          var data = {
            username: username,
            password: password,
          };
          data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
          this.$store
            .dispatch(AUTH_REQUEST, {
              data,
            })
            .then((resp) => {
              this.$router.push("/");
            })
            .catch((error) => {
              this.$log(error.response.data.user)
              if (error.response.data.status == "to_activate") {
                this.to_activate = true;
              }
              if (error.response.data.user.corporateClient)
                this.corporateClient = error.response.data.user.corporateClient;
                if(this.corporateClient == 'emicon'){
                  this.$router.push('/recovery-password?token='+this.$encryptByAES(JSON.stringify(error.response.data.user.email), process.env.CRYPTKEY)+'&corporateClient='+this.$encryptByAES(JSON.stringify(error.response.data.user.corporateClient), process.env.CRYPTKEY))
           
                }
                 });
        }
      });
    },

    resetState: function () {
      this.resend_success = false;
      this.confirmed = true;
    },

    resendConfirmEmail: function () {
      const { username } = this;

      if (username) {
        this.loadingState2 = true;
        axios({
          url: process.env.ROOT_API + "api/resend_registration_email",
          method: "POST",
          data: {
            username: username,
          },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.resend_success = true;
            this.loadingState2 = false;
          })
          .catch((error) => {
            this.loadingState2 = false;

            this.$swal({
              type: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
      } else {
        this.confirmed = true;
      }
    },
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "loginerror",
      "loadingState",
      "isAuthenticated",
      "isProfileLoaded",
      "authStatus",
    ]),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    }),
  },
  mounted: function () {},
  watch: {
    authStatus(value) {
      if (value == "not_confirmed") {
        this.confirmed = false;
      }
    },
  },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/login/index.vue